import { useState, type MouseEvent } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar as MuiAppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
} from '@mui/material';
import { useAuth } from '../auth/useAuth';
import { ThemeToggle } from './ThemeToggle';

export function AppBar() {
  const { tokens, email, signOut } = useAuth();
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const onAvatar = (e: MouseEvent<HTMLElement>) => setAnchor(e.currentTarget);
  const onClose = () => setAnchor(null);
  const onSignOut = () => { onClose(); signOut(); navigate('/'); };

  return (
    <MuiAppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        color: 'var(--ink)',
        borderBottom: '1px solid var(--rule)',
      }}
    >
      <Toolbar sx={{ px: { xs: 3, md: 6 }, py: 2, minHeight: '64px !important' }}>
        {/* Aligns the masthead with the 1120px marketing column. */}
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', maxWidth: 1120, mx: 'auto' }}>
          <Box component={RouterLink} to="/" sx={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontFamily: 'IBM Plex Mono', fontSize: '0.875rem', letterSpacing: '-0.01em' }}>
              acceptlens
            </Typography>
          </Box>
          <Box sx={{ flex: 1 }} />
          <Button component={RouterLink} to="/docs" variant="text" size="small" sx={{ mr: 1, color: 'inherit' }}>Docs</Button>
          <ThemeToggle />
          {tokens ? (
            <>
              <Typography sx={{ display: { xs: 'none', sm: 'block' }, fontFamily: 'IBM Plex Mono', fontSize: '0.8125rem', color: 'var(--ink-muted)', mr: 1.5 }}>
                {email}
              </Typography>
              <IconButton
                size="small"
                onClick={onAvatar}
                aria-label="Account menu"
                aria-haspopup="menu"
                aria-expanded={!!anchor}
                sx={{ width: 32, height: 32, border: '1px solid var(--rule)', borderRadius: 0 }}
              >
                <Box sx={{ width: 8, height: 8, backgroundColor: 'var(--accent)' }} />
              </IconButton>
              <Menu anchorEl={anchor} open={!!anchor} onClose={onClose}>
                <MenuItem component={RouterLink} to="/dashboard" onClick={onClose}>Dashboard</MenuItem>
                <Divider />
                <MenuItem onClick={onSignOut}>Sign out</MenuItem>
              </Menu>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button component={RouterLink} to="/signin" variant="text" size="small" sx={{ color: 'inherit' }}>Sign in</Button>
              <Button component={RouterLink} to="/signup" variant="contained" size="small">Sign up</Button>
            </Box>
          )}
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
}
